/* PET DOT SHOP — TOP page enhancements: scroll-reveal, card micro-interactions, flying purchase CTA. Self-hosted (CSP-safe). */
(function(){
var PAW='<svg class="pw" viewBox="0 0 24 24" fill="currentColor"><circle cx="6.5" cy="10" r="2"/><circle cx="11" cy="7.3" r="2"/><circle cx="16" cy="8" r="2"/><circle cx="19.2" cy="12" r="1.7"/><path d="M12 12.4c-2.6 0-4.6 2.1-4.6 4.3 0 1.7 1.4 2.6 3 2.3.7-.1 1.5-.3 1.6-.3s.9.2 1.6.3c1.6.3 3-.6 3-2.3 0-2.2-2-4.3-4.6-4.3z"/></svg>';
var CSS=[
/* card micro-interactions */
'.pds-card,.pds-jc{transition:transform .28s cubic-bezier(.2,.8,.2,1),box-shadow .28s ease;}',
'.pds-card:hover,.pds-jc:hover{transform:translateY(-5px);box-shadow:0 14px 34px rgba(0,0,0,.13);}',
'.pds-card:active,.pds-jc:active{transform:translateY(-1px);}',
'.pds-card .im,.pds-jc .im,.pds-card .pds-card__im,.pds-jc>.im{overflow:hidden;}',
'.pds-card img,.pds-jc .im img{transition:transform .45s cubic-bezier(.2,.8,.2,1);}',
'.pds-card:hover img,.pds-jc:hover .im img{transform:scale(1.06);}',
/* reveal (JS-gated so no-JS keeps content visible) */
'body.tfx-on .tfx-rev{opacity:0;transform:translateY(26px);}',
'.tfx-rev{transition:opacity .6s ease,transform .75s cubic-bezier(.2,.8,.2,1);}',
'body.tfx-on .tfx-rev.tfx-in{opacity:1;transform:none;}',
/* 常設フローティング「商品一覧」FAB（ヒーロー通過で登場・肉球アニメ・フッターで格納） */
'.tfab{position:fixed;right:15px;bottom:calc(20px + env(safe-area-inset-bottom));z-index:60;box-sizing:border-box;width:62px;height:62px;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:2px;border-radius:50%;border:1px solid rgba(255,255,255,.16);text-decoration:none;background:rgba(42,42,42,.6);-webkit-backdrop-filter:blur(10px) saturate(1.3);backdrop-filter:blur(10px) saturate(1.3);color:#fff;box-shadow:0 6px 20px rgba(0,0,0,.2);opacity:0;transform:translateY(14px) scale(.55);pointer-events:none;-webkit-tap-highlight-color:transparent;transition:opacity .3s ease,transform .5s cubic-bezier(.34,1.56,.5,1);}',
'.tfab.show{opacity:1;transform:none;pointer-events:auto;}',
'.tfab.show:active{transform:scale(.93);}',
'.tfab .pw{width:22px;height:22px;color:#fff;transform-origin:60% 80%;animation:tfabBob 2.6s ease-in-out infinite;}',
'.tfab .lb{font-size:9.5px;font-weight:800;letter-spacing:.03em;line-height:1;color:#fff;}',
'@keyframes tfabBob{0%,58%,100%{transform:translateY(0) rotate(0);}70%{transform:translateY(-3px) rotate(-9deg);}82%{transform:translateY(0) rotate(4deg);}}',
'@media(prefers-reduced-motion:reduce){.pds-card,.pds-jc,.pds-card img,.pds-jc .im img{transition:none;}.tfab{transition:opacity .25s ease;transform:none;}.tfab.show{transform:none;}.tfab .pw{animation:none;}}'
].join('');

function injectCSS(){var s=document.createElement('style');s.textContent=CSS;document.head.appendChild(s);}

/* ---------- reveal ---------- */
function setupReveal(root){
  if(!('IntersectionObserver' in window))return;
  var els=root.querySelectorAll('.pds-kick,.pds-h2,.pds-sub');
  var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('tfx-in');io.unobserve(e.target);}});},{rootMargin:'0px 0px -10% 0px',threshold:0.04});
  els.forEach(function(el){ if(el.classList.contains('pds-rev')||el.closest('.pds-rev'))return; el.classList.add('tfx-rev'); io.observe(el); });
}

/* ---------- persistent floating 「商品一覧」 FAB (appears past hero, retires at footer) ---------- */
function setupFly(root){
  var hero=root.querySelector('[id*="hero_custom"]')||root.querySelector('.pdh');
  var footer=document.querySelector('footer');
  var fab=document.createElement('a');fab.className='tfab';fab.href='/collections/shop';fab.setAttribute('aria-label','商品一覧を見る');
  fab.innerHTML=PAW+'<span class="lb">商品一覧</span>';
  document.body.appendChild(fab);
  function check(){
    var vh=innerHeight;
    var pastHero=hero?(hero.getBoundingClientRect().bottom < vh*0.35):(pageYOffset > vh*0.6);
    var atFooter=footer?(footer.getBoundingClientRect().top < vh*0.9):false;
    fab.classList.toggle('show', pastHero && !atFooter);
  }
  var tick=false;function onS(){if(!tick){requestAnimationFrame(function(){check();tick=false;});tick=true;}}
  addEventListener('scroll',onS,{passive:true});addEventListener('resize',onS);setInterval(check,200);check();
}

function init(){
  if(document.body.dataset.tfx)return;document.body.dataset.tfx='1';
  var root=document.querySelector('#MainContent')||document.querySelector('main')||document.body;
  injectCSS();
  document.body.classList.add('tfx-on');
  try{setupReveal(root);}catch(e){}
  try{setupFly(root);}catch(e){}
}
if(document.readyState!=='loading')init();else document.addEventListener('DOMContentLoaded',init);
})();
